import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './resources/css/common.css';
import App from './App';
import './utils/NumberUtils.js';
import './utils/DateUtils.js';
import './utils/IEUtils.js';
import './utils/JSUtils';
import { polyfill } from 'es6-promise';

polyfill();

ReactDOM.render(<App/>,
     document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js